import ProjectSearchResults from './ProjectSearchResults';

export default ProjectSearchResults;
